import React from 'react'

import Button from '@SonarCX/components/atoms/Button2'

import useStyles from './styles'

type SettingsSaveButtonProps = {
  onClick: () => void
  loading?: boolean
  disabled?: boolean
}

const SettingsSaveButton: React.FC<SettingsSaveButtonProps> = ({
  onClick,
  loading,
  disabled
}) => {
  const classes = useStyles()

  return (
    <div className={classes.root}>
      <Button
        onClick={onClick}
        loading={loading}
        disabled={disabled}
        className={classes.button}
      >
        SAVE
      </Button>
    </div>
  )
}

export default SettingsSaveButton
